module.exports = __webpack_public_path__ + "img/AvatarHamochi.7d0b0e3a.png";